import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import NumberInsertField from './../../components/NumberInsertField';
import TextFormatter from './../../components/TextFormatter';

class ArajanlatTetelOpciokInsert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            arajanlatTetelOpciok_arajanlat_tetel_id: ''
            , arajanlatTetelOpciok_manualis_sorszam: ''
            , arajanlatTetelOpciok_megnevezes: ''
            , arajanlatTetelOpciok_hivatkozas: ''
            , arajanlatTetelOpciok_netto_ar: ''
            , arajanlatTetelOpciok_darabszam: this.props.arajanlatTetelek_darabszam
            , arajanlatTetelOpciok_nettoOsszesen: ''
            , arajanlatTetelOpciok_megjegyzes: ''

        }


        this.references = [];
        this.references['arajanlatTetelOpciok_arajanlat_tetel_id'] = React.createRef();
        this.references['arajanlatTetelOpciok_manualis_sorszam'] = React.createRef();
        this.references['arajanlatTetelOpciok_megnevezes'] = React.createRef();
        this.references['arajanlatTetelOpciok_hivatkozas'] = React.createRef();
        this.references['arajanlatTetelOpciok_netto_ar'] = React.createRef();
        this.references['arajanlatTetelOpciok_darabszam'] = React.createRef();
        this.references['arajanlatTetelOpciok_nettoOsszesen'] = React.createRef();
        this.references['arajanlatTetelOpciok_megjegyzes'] = React.createRef();


        this.validators = [];
        this.validators['arajanlatTetelOpciok_arajanlat_tetel_id'] = {fieldName: 'arajanlatTetelOpciok_arajanlat_tetel_id', dataType: 'INT', value: this.state.arajanlatTetelOpciok_arajanlat_tetel_id, mandatory: false, min: null, max: null};
        this.validators['arajanlatTetelOpciok_manualis_sorszam'] = {fieldName: 'arajanlatTetelOpciok_manualis_sorszam', dataType: 'VARCHAR', value: this.state.arajanlatTetelOpciok_manualis_sorszam, mandatory: false, min: null, max: null};
        this.validators['arajanlatTetelOpciok_megnevezes'] = {fieldName: 'arajanlatTetelOpciok_megnevezes', dataType: 'VARCHAR', value: this.state.arajanlatTetelOpciok_megnevezes, mandatory: false, min: null, max: null};
        this.validators['arajanlatTetelOpciok_hivatkozas'] = {fieldName: 'arajanlatTetelOpciok_hivatkozas', dataType: 'VARCHAR', value: this.state.arajanlatTetelOpciok_hivatkozas, mandatory: false, min: null, max: null};
        this.validators['arajanlatTetelOpciok_netto_ar'] = {fieldName: 'arajanlatTetelOpciok_netto_ar', dataType: 'INT', value: this.state.arajanlatTetelOpciok_netto_ar, mandatory: false, min: null, max: null};
        this.validators['arajanlatTetelOpciok_darabszam'] = {fieldName: 'arajanlatTetelOpciok_darabszam', dataType: 'DOUBLE', value: this.state.arajanlatTetelOpciok_darabszam, mandatory: true, min: null, max: null};
        this.validators['arajanlatTetelOpciok_nettoOsszesen'] = {fieldName: 'arajanlatTetelOpciok_nettoOsszesen', dataType: 'DOUBLE', value: this.state.arajanlatTetelOpciok_nettoOsszesen, mandatory: true, min: null, max: null};
        this.validators['arajanlatTetelOpciok_megjegyzes'] = {fieldName: 'arajanlatTetelOpciok_megjegyzes', dataType: 'VARCHAR', value: this.state.arajanlatTetelOpciok_megjegyzes, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

    }

    componentDidMount() {
        this.reset();
    }

    setFocusedComponent = function () {
        try {
            for (var i = 0; i < Object.keys(this.references).length; i++) {
                let first = Object.keys(this.references)[i];

                if (this.references[first].current != null && typeof this.references[first].current.focus != 'undefined') {
                    this.references[first].current.focus();
                    return false;
                }
            }
        } catch (e) {
            console.log("can not set focus on first component");
        }
    }

    reset = function () {
        this.setFocusedComponent();
        this.setState({arajanlatTetelOpciok_arajanlat_tetel_id: ''
            , arajanlatTetelOpciok_manualis_sorszam: ''
            , arajanlatTetelOpciok_megnevezes: ''
            , arajanlatTetelOpciok_hivatkozas: ''
            , arajanlatTetelOpciok_netto_ar: ''
            , arajanlatTetelOpciok_darabszam: this.props.arajanlatTetelek_darabszam
            , arajanlatTetelOpciok_nettoOsszesen: ''
            , arajanlatTetelOpciok_megjegyzes: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }
    setNettoOsszes = function () {
        var darabszam = (this.state.arajanlatTetelOpciok_darabszam == null || this.state.arajanlatTetelOpciok_darabszam == '') ? 1 : this.state.arajanlatTetelOpciok_darabszam;
        this.state.arajanlatTetelOpciok_nettoOsszesen = this.state.arajanlatTetelOpciok_netto_ar * darabszam;

    }

    getForm = function () {
        this.setNettoOsszes();
        return <Container>
        
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_manualis_sorszam')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
        
                    id={'arajanlatTetelOpciok_manualis_sorszam'} 
                    value={this.state.arajanlatTetelOpciok_manualis_sorszam}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_manualis_sorszam']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_darabszam')}</Col>
                <Col style={{textAlign: 'right'}}>
                <NumberInsertField 
                    id={'arajanlatTetelOpciok_darabszam'} 
                    value={this.state.arajanlatTetelOpciok_darabszam}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_darabszam']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
        
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_megnevezes')}</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'right'}}>
                <TextFormatter 
                    sablonKivalasztoval={false} 
                    id={'arajanlatTetelOpciok_megnevezes'} 
                    value={this.state.arajanlatTetelOpciok_megnevezes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_megnevezes']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_hivatkozas')}</Col>
                <Col md="10" style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'arajanlatTetelOpciok_hivatkozas'} 
                    value={this.state.arajanlatTetelOpciok_hivatkozas}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_hivatkozas']}
                    editable={true}
                    theme={this.props.theme}
                    style={{minWidth: '100%'}}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_netto_ar')}</Col>
                <Col style={{textAlign: 'right'}}>
                <NumberInsertField 
                    id={'arajanlatTetelOpciok_netto_ar'} 
                    value={this.state.arajanlatTetelOpciok_netto_ar}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_netto_ar']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
        
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('arajanlatTetelOpciok_nettoOsszesen')}</Col>
                <Col style={{textAlign: 'right'}}>
                <NumberInsertField 
                    id={'arajanlatTetelOpciok_nettoOsszesen'} 
                    value={this.state.arajanlatTetelOpciok_nettoOsszesen}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['arajanlatTetelOpciok_nettoOsszesen']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                stateClone[property] = additionalParam[property];
            }
        }
        return stateClone;
    }

    insert = function (e) {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }

        var method = e.target.id;
        var self = this;

        var params = this.concatAdditionalParams();

        try {
            const url = ajax.getUrlBase() + "modules/ArajanlatTetelOpciok/arajanlatTetelOpciokFormInsert.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify(params)
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            self.transactionSuccess();
                            if (method == 'save') {
                                self.closeForm();
                            }
                            if (method == 'save_new') {
                                self.reset();
                            }
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        self.state.defaultUpdateBlocked = false;
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.state.defaultUpdateBlocked = false;
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.state.defaultUpdateBlocked = false;
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.state.defaultUpdateBlocked = false;
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight: 550, minWidth: 1100}}>
            <div className={'popupWrapper' + className} id="ArajanlatTetelOpciokInsert">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('ArajanlatTetelOpciokInsert')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.insert.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('save')}</Button>&nbsp;&nbsp;&nbsp;      
                        <Button className={'btn-sm'} id={'save_new'} onClick={this.insert.bind(this)} variant="info" style={{marginTop: '5px'}}>{lang.getTitle('new')}</Button>      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default ArajanlatTetelOpciokInsert;

